<!-- Created by Maxim Bon. on 13/05/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<div fxLayout="row" fxLayoutAlign="space-between start" class="header m-b-16">
  <h2 class="mat-h2 m-b-0" fxFlex>{{data.title}}</h2>
  <curr-icon-button icon="close" (click)="dialogRef.close()"></curr-icon-button>
</div>
<div [formGroup]="form" class="name-container m-b-16" fxLayout="column" fxLayoutAlign="center center">
  <curr-input
    [placeholder]="'shared.taskList.popup.task' | translate"
    [formGroup]="form"
    controlName="name"
    class="full-width"
    [errorMessage]="form.controls['name'].hasError('required') ? ('shared.taskList.popup.nameRequired' | translate) : ('shared.taskList.popup.nameMaxLength' | translate)"
  ></curr-input>
  <curr-datepicker
    class="full-width"
    [placeholder]="'shared.taskList.popup.date' | translate"
    [activeFromToday]="true"
    [isReadOnly]="true"
    [isRequired]="true"
    [suffix]="'calendar-today'"
    [value]="oldDeadlineDate"
    [errorMessage]="form.controls['deadlineDate'].hasError('required') ? ('shared.taskList.popup.dateRequired' | translate) : ''"
    (onInputBlur)="setStartDate($event)"
    (valueChange)="setStartDate($event)"></curr-datepicker>
  <curr-timepicker
    class="full-width"
    [placeholder]="'shared.taskList.popup.time' | translate"
    [suffix]="'time'"
    [value]="oldDeadlineTime"
    [isReadOnly]="true"
    [isRequired]="true"
    [errorMessage]="form.controls['deadlineTime'].hasError('required') ? ('shared.taskList.popup.timeRequired' | translate) : ''"
    (onInputBlur)="setStartTime($event)"
    (valueChange)="setStartTime($event)"></curr-timepicker>
  <div class="m-t-8 full-width" fxLayout="row" fxLayoutAlign="end center">
    <curr-button variant="text" (btnClick)="dialogRef.close()" size="big">{{ 'shared.taskList.popup.cancel' | translate }}</curr-button>
    <curr-button variant="contained" class="m-l-16" [isDisabled]="form.invalid" (btnClick)="save()" size="big">{{ 'shared.taskList.popup.save' | translate }}</curr-button>
  </div>
</div>
